import WhatsappTemplateScreen from "../../../screens/WhatsappTemplate/WhatsappTemplateScreen";

export const Whatsapp4uMarComPage = () => {
  return <WhatsappTemplateScreen software="MarCom" />;
};
